/**
 * The My brand tabs, in the order they are drawn.
 *
 * One list, in one place, the way `settingsTabs` holds Settings': the tab now
 * sits in the URL, so something outside this screen can link to one — the
 * dashboard's "Create plans" step is the first thing that does.
 */

import type { TabItem } from "../../components/ui";
import type { BrandTabId } from "./types/brand.types";

export const BRAND_TABS: TabItem<BrandTabId>[] = [
  { id: "details", label: "Details" },
  { id: "plans", label: "Plans" },
  { id: "services", label: "Services" },
  { id: "form", label: "Form" },
  { id: "configuration", label: "Configuration & integration" },
  { id: "guidelines", label: "Guidelines & policy" },
];

/** An unknown or missing `?tab=` opens on Details, rather than on nothing. */
export const brandTabFromParam = (value: string | null): BrandTabId =>
  BRAND_TABS.some((tab) => tab.id === value) ? (value as BrandTabId) : "details";
